import React, { useEffect, useState } from "react";
import { useChartContext } from "../../Context/ChartsContext";
import LineRaceChart from "../../CHARTS/LineRaceChart";
import DottedBarChart from "../../CHARTS/DottedBarChart";
import { MdVisibility } from "react-icons/md";
import { getDaysInMonth } from "../../Utilitie";
import Punctuality from "../PunctualityFolder/Punctuality";
import Loading from "../../Extra/Loading";
const PunctualityVS = ({ vs, head, from }) => {
  const { bestSheetDataObj, fetchBestSheetData } = useChartContext();
  const [visibleTable, setVisibleTable] = useState(null);
  const [bestSheetData, setBestSheetData] = useState(null);
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    setVisibleTable(bestSheetDataObj.visibleTable);
    setBestSheetData(bestSheetDataObj.bestSheetData);
  }, [bestSheetDataObj]);
  useEffect(() => {
    if (from === "diary") {
      fetchBestSheetData();
    }
  }, [from]);
  useEffect(() => {
    if (from === "diary") {
      let year = [];
      let temVisTable = {};
      if (bestSheetDataObj?.fyTotal?.length > 0) {
        bestSheetDataObj?.fyTotal.map((value, i) => {
          year.push(value.F_YEAR);
        });
      }
      year.sort((a, b) => b.replace("_", "") - a.replace("_", ""));
      setVisibleTable({ [year[0]]: true, [year[1]]: true });
    }
  }, [bestSheetDataObj, from]);
  function parseTime(str) {
    const [month, fy] = str.split("\n");
    const [startYear, endYear] = fy.split("-").map(Number);

    // Sort mainly by startYear
    return { month, startYear, endYear };
  }

  useEffect(() => {
    if (bestSheetData && visibleTable) {
      let newChartData = [];

      Object.entries(visibleTable).forEach(([key, value]) => {
        if (value) {
          bestSheetData.forEach((fyObj) => {
            if (fyObj.F_YEAR === key) {
              fyObj.months.forEach((monthObj) => {
                let days = getDaysInMonth(
                  fyObj.F_YEAR,
                  monthObj.A_MONTH.toUpperCase()
                );
                if (vs === "TotalTrain") {
                  // console.log(monthObj.data);
                  newChartData.push({
                    time: `${monthObj.A_MONTH}\n${fyObj.F_YEAR.replace(
                      "_",
                      "-"
                    )}`,
                    //   MEXP: Number(monthObj.data.PUN_MAIL),
                    Punctuality: (
                      (Number(monthObj.data.PUN_MAIL) *
                        Number(monthObj.data.MEXP_RPT) +
                        Number(monthObj.data.PUN_PASS) *
                          Number(monthObj.data.PASS_RPT)) /
                      (Number(monthObj.data.MEXP_RPT) +
                        Number(monthObj.data.PASS_RPT))
                    ).toFixed(2),
                    // GOODS: (monthObj.data.TOTAL_RKS / days).toFixed(0),
                    // SPEED: monthObj.data.SPEED,
                    TotalTrain: (
                      monthObj.data.MEXP_RPT / days +
                      monthObj.data.PASS_RPT / days +
                      monthObj.data.TOTAL_RKS / days
                    ).toFixed(0),
                  });
                }
                if (vs === "LDG_WGN") {
                  newChartData.push({
                    time: `${monthObj.A_MONTH}\n${fyObj.F_YEAR.replace(
                      "_",
                      "-"
                    )}`,
                    //   MEXP: Number(monthObj.data.PUN_MAIL),
                    Punctuality: (
                      (Number(monthObj.data.PUN_MAIL) *
                        Number(monthObj.data.MEXP_RPT) +
                        Number(monthObj.data.PUN_PASS) *
                          Number(monthObj.data.PASS_RPT)) /
                      (Number(monthObj.data.MEXP_RPT) +
                        Number(monthObj.data.PASS_RPT))
                    ).toFixed(2),
                    // GOODS: (monthObj.data.TOTAL_RKS / days).toFixed(0),
                    // SPEED: monthObj.data.SPEED,
                    LDG_WGN: (monthObj.data.LDG_WGN / days)
                      // monthObj.data.PASS_RPT / days +
                      // monthObj.data.TOTAL_RKS / days
                      .toFixed(0),
                  });
                }

                if (vs === "Coaching Trains") {
                  // console.log(monthObj.data);
                  newChartData.push({
                    time: `${monthObj.A_MONTH}\n${fyObj.F_YEAR.replace(
                      "_",
                      "-"
                    )}`,
                    //   MEXP: Number(monthObj.data.PUN_MAIL),
                    "Pass Pun": (
                      (Number(monthObj.data.PUN_PASS) *
                        Number(monthObj.data.PASS_RPT)) /
                      Number(monthObj.data.PASS_RPT)
                    ).toFixed(1),
                    "Mexp Pun": (
                      (Number(monthObj.data.PUN_MAIL) *
                        Number(monthObj.data.MEXP_RPT)) /
                      Number(monthObj.data.MEXP_RPT)
                    ).toFixed(1),
                    // //////////// BOTH PUNCTUALITY ////////////////////
                    //  Punctuality: (
                    //   (Number(monthObj.data.PUN_MAIL) *
                    //     Number(monthObj.data.MEXP_RPT) +
                    //     Number(monthObj.data.PUN_PASS) *
                    //       Number(monthObj.data.PASS_RPT)) /
                    //   (Number(monthObj.data.MEXP_RPT) +
                    //     Number(monthObj.data.PASS_RPT))
                    // ).toFixed(2),
                    // GOODS: (monthObj.data.TOTAL_RKS / days).toFixed(0),
                    // SPEED: monthObj.data.SPEED,
                    "Coaching Trains": (
                      monthObj.data.MEXP_RPT / days +
                      monthObj.data.PASS_RPT / days
                    ).toFixed(0),
                    "Mexp Trains": (monthObj.data.MEXP_RPT / days).toFixed(0),
                    "Pass Trains": (monthObj.data.PASS_RPT / days).toFixed(0),
                  });
                }
                if (vs === "DWB") {
                  // console.log(monthObj.data);
                  newChartData.push({
                    time: `${monthObj.A_MONTH}\n${fyObj.F_YEAR.replace(
                      "_",
                      "-"
                    )}`,
                    //   MEXP: Number(monthObj.data.PUN_MAIL),
                    Punctuality: (
                      (Number(monthObj.data.PUN_MAIL) *
                        Number(monthObj.data.MEXP_RPT) +
                        Number(monthObj.data.PUN_PASS) *
                          Number(monthObj.data.PASS_RPT)) /
                      (Number(monthObj.data.MEXP_RPT) +
                        Number(monthObj.data.PASS_RPT))
                    ).toFixed(2),
                    // GOODS: (monthObj.data.TOTAL_RKS / days).toFixed(0),
                    // SPEED: monthObj.data.SPEED,
                    DWB: (monthObj.data.DWB / days).toFixed(0),
                  });
                }
              });
            }
          });
        }
      });
      newChartData.sort((a, b) => {
        const A = parseTime(a.time);
        const B = parseTime(b.time);

        // First sort by start year (ascending)
        if (A.startYear !== B.startYear) {
          return A.startYear - B.startYear;
        }

        // If same year → sort by month number
        const monthOrder = [
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
          "Jan",
          "Feb",
          "Mar",
        ];

        return monthOrder.indexOf(A.month) - monthOrder.indexOf(B.month);
      });
      setChartData(newChartData);
    }
  }, [visibleTable, bestSheetData]);

  return (
    <div className="papaDivNM" style={{ background: "rgba(0,0,0,0)" }}>
      {bestSheetDataObj.loading && <Loading />}
      <div className="bg-dark text-white p-1">
        <h6>
          Punctuality VS {vs === "TotalTrain" && "Total Train (Avg per day)"}
          {vs === "LDG_WGN" && "Loading Wagon "}{" "}
          {vs === "Coaching Trains" && "Coaching Trains  (Avg per day) "}
          {vs === "DWB" && "DWB (Avg per day) "}
          {visibleTable &&
            Object.entries(visibleTable).map(([key, value], index) => {
              return (
                <React.Fragment key={index}>
                  {value ? `${key.replace("_", "-")}, ` : null}
                </React.Fragment>
              );
            })}
        </h6>
      </div>
      <LineRaceChart
        data={chartData}
        title={"MEXP,PASS,GOODS performance graph"}
      />
      {/* <DottedBarChart data={chartData} /> */}
    </div>
  );
};
export default PunctualityVS;
